import classNames from 'classnames';
import NeumorphBox, { NeumorphType } from '../common/ui/NeumorphBox.tsx';
import { useContext } from 'react';
import { LanguageContext } from '@/common/Language.tsx';

export default function Disclaimer({ hide }: { hide: () => void }) {
  const { t, toggleLang } = useContext(LanguageContext);
  return (
    <div
      style={{ zIndex: 99999 }}
      className={classNames(
        'absolute',
        'inset-0',
        'bg-gray-100/90',
        'flex',
        'flex-col',
        'justify-center',
        'p-[30px]'
      )}
    >
      <div
        style={{ zIndex: 99999 }}
        className={classNames(
          'mx-auto',
          'max-w-[1000px]',
          'bg-gray-100',
          'shadow-xl',
          'p-[30px]',
          'rounded-[12px]',
          'max-h-[100vh]',
          'overflow-auto'
        )}
      >
        <div
          className={classNames(
            'flex',
            'flex-col',
            'md:flex-row',
            'gap-[40px]',
            'md:justify-around'
          )}
        >
          <div
            className={classNames(
              'flex-1',
              'md:w-1/2',
              'max-w-[500px]',
              'text-center',
              'flex',
              'flex-col',
              'justify-between',
              'gap-[30px]'
            )}
          >
            <div>
              <h2 className={classNames('text-[22px]')}>Disclaimer</h2>
              <p>
                This is a demonstrator under development, and as such not
                intended as basis for decision-making. The content of these
                pages is based on a research project with many contributors.
                Details and limitations of individual contributions may be
                documented in related publications by the respective authors.
                All information presented here comes without any warranty and
                without guarantee for correctness. Liability claims regarding
                damage caused by the use or non-use of any information provided,
                including any kind of information which is incomplete or
                incorrect, will therefore be rejected. As the development of
                this tool is ongoing, parts of the pages or the complete
                publication including all offers and information might be
                extended, changed or partly or completely deleted without
                separate announcement.
              </p>
            </div>
            <div className={classNames()}>
              <NeumorphBox
                onClick={hide}
                type={NeumorphType.Hoverable}
                inline={true}
              >
                🇺🇸 I understand and accept
              </NeumorphBox>
            </div>
          </div>
          <div
            className={classNames(
              'flex-1',
              'md:w-1/2',
              'max-w-[500px]',
              'text-center',
              'flex',
              'flex-col',
              'justify-between',
              'gap-[30px]'
            )}
          >
            <div>
              <h2 className={classNames('text-[22px]')}>Disclaimer</h2>
              <p>
                Dies ist ein Demonstrator in der Entwicklungsphase, und als
                solcher nicht als Entscheidungsgrundlage bestimmt. Der Inhalt
                dieser Seiten basiert auf einem Forschungsprojekt mit vielen
                Beitragenden. Details und Limitierungen einzelner Beiträge sind
                ggf. in entsprechenden Fachpublikationen der jeweiligen
                AutorInnen dokumentiert. Alle hier dargestellten Informationen
                erfolgen ohne Gewähr und ohne Garantie für ihre Richtigkeit. In
                keinem Fall wird für Schäden, die sich aus der Verwendung oder
                Nichtverwendung abgerufener Informationen ergeben,
                einschließlich unvollständiger oder inkorrekter Informationen,
                Haftung übernommen. Da die Entwicklung dieses Tools andauert,
                können Teile oder der gesamte Inhalt geändert, erweitert, oder
                gelöscht werden, ohne gesonderte Ankündigung.
              </p>
            </div>
            <div className={classNames()}>
              <NeumorphBox
                onClick={() => {
                  toggleLang();
                  hide();
                }}
                type={NeumorphType.Hoverable}
                inline={true}
              >
                🇩🇪 Ich verstehe und akzeptiere
              </NeumorphBox>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
